module.exports = __webpack_public_path__ + "e87ed18e2998dc4d46a6d098f5e9949e.svg";